import apiClient from "./apiClient";

export function listKpis(params = {}) {
  return apiClient.get("/kpis", { params });
}

export function getKpi(id) {
  return apiClient.get(`/kpis/${id}`);
}

export function createKpi(payload) {
  return apiClient.post("/kpis", payload);
}

export function updateKpi(id, payload) {
  return apiClient.patch(`/kpis/${id}`, payload);
}

export function archiveKpi(id) {
  return apiClient.delete(`/kpis/${id}`);
}

export function restoreKpi(id, payload = {}) {
  return apiClient.post(`/kpis/${id}/restore`, payload);
}

export function listThresholds(id) {
  return apiClient.get(`/kpis/${id}/thresholds`);
}

export function saveThresholds(id, thresholds) {
  return apiClient.put(`/kpis/${id}/thresholds`, thresholds);
}

export function listMeasurements(id, params = {}) {
  return apiClient.get(`/kpis/${id}/measurements`, { params });
}

export function addMeasurement(id, payload) {
  return apiClient.post(`/kpis/${id}/measurements`, payload);
}

export function bulkMeasurements(id, items) {
  return apiClient.post(`/kpis/${id}/measurements/bulk`, { items });
}

export function approveMeasurement(id, measurementId) {
  return apiClient.post(`/kpis/${id}/measurements/${measurementId}/approve`);
}

export function listLinks(id) {
  return apiClient.get(`/kpis/${id}/links`);
}

export function addLink(id, payload) {
  return apiClient.post(`/kpis/${id}/links`, payload);
}

export function deleteLink(id, payload) {
  return apiClient.delete(`/kpis/${id}/links`, { data: payload });
}

export function getEntityKpis(entityType, entityId) {
  return apiClient.get(`/entities/${entityType}/${entityId}/kpis`);
}

export function updateFormula(id, payload) {
  return apiClient.put(`/kpis/${id}/formula`, payload);
}

export function evaluateKpi(id) {
  return apiClient.post(`/kpis/${id}/evaluate`);
}

export function listDashboards() {
  return apiClient.get("/kpi-dashboards");
}

export function createDashboard(payload) {
  return apiClient.post("/kpi-dashboards", payload);
}

export function getDashboard(id) {
  return apiClient.get(`/kpi-dashboards/${id}`);
}

export function updateDashboard(id, payload) {
  return apiClient.put(`/kpi-dashboards/${id}`, payload);
}

export function deleteDashboard(id) {
  return apiClient.delete(`/kpi-dashboards/${id}`);
}

export function getExecutiveDashboardSummary(params = {}) {
  return apiClient.get("/kpi-dashboards/executive/summary", { params });
}

export function exportKpisCsv() {
  return apiClient.get("/kpis/export/csv", { responseType: "blob" });
}

export function exportKpiCsv(id) {
  return apiClient.get(`/kpis/${id}/export/csv`, { responseType: "blob" });
}

export function exportKpiPdf(id) {
  return apiClient.get(`/kpis/${id}/export/pdf`, { responseType: "blob" });
}

export function listAlerts(id) {
  return apiClient.get(`/kpis/${id}/alerts`);
}

export function createAlert(id, payload) {
  return apiClient.post(`/kpis/${id}/alerts`, payload);
}

export function updateAlert(id, alertId, payload) {
  return apiClient.put(`/kpis/${id}/alerts/${alertId}`, payload);
}

export function deleteAlert(id, alertId) {
  return apiClient.delete(`/kpis/${id}/alerts/${alertId}`);
}
